import {mapInstruction} from './normalizeSections';
import {orderInstructionInSection} from './orderInstructions';

export default (oldState, newInstructions) => {
	const newInstruction = newInstructions[0];
	const resp = oldState.map((section) => {
		if (section.id === newInstruction.sectionId) {
			const mappedInstruction = mapInstruction(newInstruction, newInstruction.sectionId);
			const ordered = orderInstructionInSection({
				...section,
				instructions: [...section.instructions, mappedInstruction]
			});

			return ordered;
		}
		return section;
	});
	return resp;
};
